import { DefaultTheme } from '../../components/theme';
import { CSS as TagIconCSS } from '../tag.icon/tag.icon.style';
import { CSS as CollectionCardCSS } from './collection.card.style';

export const CSS = {
	row: 'c-VariantCard__row',
	label: 'c-VariantCard__label',
};

// Match the collection card's icon size — TagIcon inherits its box from this container.
const ICON_SIZE = DefaultTheme.space(4);

export const Style = {
	// Reuse the job-list row look (.c-CollectionCard); the compound selector wins the indent over the base padding.
	[`${CollectionCardCSS.container}.${CSS.row}`]: {
		'padding-left': DefaultTheme.space(8),
	},
	[`${CollectionCardCSS.container}.${CSS.row} .${TagIconCSS.container}`]: {
		flex: '0 0 auto',
		width: ICON_SIZE,
		height: ICON_SIZE,
	},
	[`${CollectionCardCSS.container}.${CSS.row} .${TagIconCSS.bareContainer}`]: {
		flex: '0 0 auto',
		width: ICON_SIZE,
		height: ICON_SIZE,
	},
	[CSS.label]: {
		flex: '1',
		'padding-left': DefaultTheme.space(3),
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
	},
};
